module.exports = __webpack_public_path__ + "img/coupon-detail.eee28c32.png";